module.exports = __webpack_public_path__ + "static/media/wellness-web-1.622e98b8.jpg";